export type RowColWidths = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export const rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
